import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo/Pontuei_Logo_1.png'


const _withScopeId = n => (_pushScopeId("data-v-1fdcac2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page-loader flex-column loader-z-index"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-6 fw-bold mt-5" }, "Carregando...", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "page-loader flex-column loader-z-index"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  class: "h-80px",
  src: _imports_0
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "spinner-border text-white",
    role: "status"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-white fs-6 fw-bold ms-5" }, "Carregando...")
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "page-loader loader-z-index"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Carregando...")
], -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loaderType === 'spinner-message')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
    : (_ctx.loaderType === 'spinner-logo')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
}